// src/pages/Reports/SalesTaxLedger/SalesTaxLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData, fetchData } from "../../../apiservice/apis";

export const fetchSalesTaxLedger = createAsyncThunk(
  "salesTaxLedger/fetch",
  async ({ accId, fromDate, toDate }, { rejectWithValue }) => {
    try {
      // ✅ getTaxLedgerApi equivalent
      const res = await postData("/reports/get-tax-ledger", {
        accId,
        dateFrom: fromDate,
        dateTo: toDate,
      });

      const { opening_balance, ledger, closing_balance, totals } = res.data;
      // Map data for the table
      const mapped = ledger.map((row, index) => ({
        id: `${row.vch_no}-${index}`,
        date: row.created_date,
        particular: row.particular,
        vch_no: row.vch_no,
        vch_type: row.vch_type,
        debit: Number(row.debit_amount || 0),
        credit: Number(row.credit_amount || 0),
        balance: Number(row.balance || 0),
        cgst_amount: row.cgst_amount,
        sgst_amount: row.sgst_amount,
        igst_amount: row.igst_amount,
      }));

      return {
        list: mapped,
        totals,
        opening_balance: Number(opening_balance || 0),
        closing_balance: Number(closing_balance || 0),
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
